<template>
  <div>
    <v-layout justify-center mt-3 wrap>

        <v-flex  xs2 mx-3 v-if="activeaccounts">
        <v-card min-width="120px" hover color="light-green" height="80px" class="rounded-card" @click="navigateServiceAccounts()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Active Accounts</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{activeaccounts.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="pendingapplications">
        <v-card min-width="120px" hover color="blue" height="80px" class="rounded-card" @click="navigateApplications()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">New Applications</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{pendingapplications.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="changerequest">
        <v-card min-width="120px" hover color="orange" height="80px" class="rounded-card" @click="navigateServiceAccounts()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Change Requests</h3>
              </v-flex>
              <v-flex xs12>
                <h2 class="font-weight-bold">{{changerequest.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs2 mx-3 v-if="cancellations">
        <v-card min-width="120px" hover color="red" height="80px" class="rounded-card" @click="navigateCancellations()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Cancellations</h3>
              </v-flex>
              <v-flex xs12>
                <h2 class="font-weight-bold">{{cancellations.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
     

    </v-layout>
    <v-layout mt-2 wrap justify-center align-center>
        <v-flex xs6 sm4 md4 v-if="ispdata.length>0">
         <barchart
      v-if="loaded"
      :chartdata="ispPackagesChartData"
      :options="ispPackagesChartOptions">
      </barchart>
      <!-- <doughnutchart
      v-if="loaded"
      :chartdata="ispPackagesChartData"
      :options="ispPackagesChartOptions">
      </doughnutchart> -->
      </v-flex>
       <v-flex xs6 sm4 md4 v-if="ispdata.length>0">
      <barchart
      v-if="loaded"
      :chartdata="ispChartData"
      :options="ispChartOptions">
      </barchart>
      </v-flex>
       <v-flex xs6 sm3 md3>
      
          <v-container  text-lg-center pt-5 text-xs-left>
              <v-layout align-center justify-left text-xs-left>
                  <v-card flat color="white" text-xs-left>
                  <v-flex xs12 sm12 md12>
                      <v-layout my-5 wrap >
                          <v-flex xs2 my-2><v-icon>home</v-icon></v-flex>
                          <v-flex xs8 my-2><h3>Units Passed: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="purple"> {{unitspassed.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>share</v-icon></v-flex>
                          <v-flex xs8 my-2><h3 >Units Connected: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="orange"> {{unitsconnected.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>devices_other</v-icon></v-flex>
                          <v-flex xs8 my-2><h3>Service Accounts: </h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="light-green"> {{activeaccounts.count}}</v-chip></v-flex>

                      <!-- </v-layout>

                       <v-layout my-5 > -->
                          <v-flex xs2 my-2><v-icon>wifi</v-icon></v-flex>
                          <v-flex xs8 my-2><h3 >Provisioned Connections:</h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="blue"> {{provisionedconnectionscount.count}}</v-chip></v-flex>

                            <v-flex xs2 my-2><v-icon>settings</v-icon></v-flex>
                          <v-flex xs8 my-2><h3 >Non-billable Connections:</h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="blue"> {{provisionedconnectionscount.count - activeaccounts.count}}</v-chip></v-flex>
                          <v-flex xs2 my-2><v-icon>trending_up</v-icon></v-flex>
                          <v-flex xs8 my-2><h3>ARPU {{arpuPeriod}}:</h3></v-flex>
                          <v-flex xs2 my-2><v-chip class="white--text" color="teal"><span v-if="platformArpu !== null">{{platformArpu | currency}}</span><span v-else>–</span></v-chip></v-flex>

                      </v-layout>
          </v-flex>
          </v-card>
          </v-layout>
          </v-container>
          </v-flex>
    </v-layout>
    <v-layout justify-center>
       <v-flex xs10 sm10 md10 v-if="networkdata.length>6">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs10 sm6 md6 v-else-if="networkdata.length>3">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs10 sm4 md4 v-else-if="networkdata.length>0">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
    </v-layout>
    
    <v-layout justify-center>
      <v-flex xs10 sm8 md6>
        <v-card flat color="white" class="mt-4">
          <v-card-title><h3>ARPU per Estate {{arpuPeriod}}</h3></v-card-title>
          <v-data-table
            :headers="estateArpuHeaders"
            :items="estateArpuList"
            item-key="id"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.accounts}}</td>
              <td class="text-xs-right"><span v-if="props.item.arpu !== null">{{props.item.arpu | currency}}</span><span v-else>–</span></td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center v-if="estateUnitsList.length > 0">
      <v-flex xs10 sm8 md6>
        <v-card flat color="white" class="mt-4">
          <v-card-title><h3>Units per Estate</h3></v-card-title>
          <v-data-table
            :headers="estateUnitsHeaders"
            :items="estateUnitsList"
            item-key="id"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.units}}</td>
              <td class="text-xs-center">{{props.item.active}}</td>
              <td class="text-xs-right"><span v-if="props.item.pct !== null">{{props.item.pct}}%</span><span v-else>&ndash;</span></td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import BarChart from './BarChart.vue';
import getEstateArpu from '@/services/EstateArpu';
import Api from '@/services/Api';
import PieChart from './PieChart.vue';
import LineChart from './LineChart.vue';
import DoughnutChart from './DoughnutChart.vue';

export default {
components: { 
  barchart: BarChart,
  piechart: PieChart,
  linechart: LineChart,
  doughnutchart: DoughnutChart
  },
  props: ["activeaccounts", "changerequest", "cancellations", "customerrequest", "networkdata", "networkspeeds", "packagedata", "pendingapplications",
  "unitspassed", "unitsconnected", "provisionedconnectionscount", "telemetryconnections", "ispdata"],
  data(){
      return {
          loaded: false,
          estateArpuRows: [],
          estateUnitsRows: [],
          estateUnitsHeaders: [
            { text: "Estate", align: "left", value: "name", sortable: false },
            { text: "Number of Units", align: "center", value: "units", sortable: false },
            { text: "Active Service Accounts", align: "center", value: "active", sortable: false },
            { text: "Active Percentage", align: "right", value: "pct", sortable: false }
          ],
          arpuPeriod: "",
          estateArpuHeaders: [
            { text: "Estate", align: "left", value: "name", sortable: false },
            { text: "Accounts", align: "center", value: "accounts", sortable: false },
            { text: "ARPU", align: "right", value: "arpu", sortable: false }
          ],
          ispPackagesChartData: {},
          ispPackagesChartOptions: {},
          networkChartData: {},
          networkChartOptions: {},
          stackedData: {},
          stackedDataOptions: {},
          ispChartData: {},
          ispChartDataOptions: {},
          downloadSpeeds:[],
          tempPackageData: []
      }
  },
  created(){
        this.loaded = false
        this.loadCharts() 
        this.loadEstateArpu()
        this.loadEstateUnits()

  },
  async mounted(){
      //this.loadCharts()
  },
  computed: {
    platformArpu() {
      var rec = 0, acc = 0;
      (this.estateArpuRows || []).forEach(function (r) {
        var s = Number(r.recurringSales), a = Number(r.accounts);
        if (isFinite(s)) rec += s;
        if (isFinite(a)) acc += a;
      });
      return acc > 0 ? rec / acc : null;
    },
    // Same figures as the Networks page: units = addresses with a plain unit number,
    // active = live service accounts. Both come from /locationnetworks/basic/active.
    estateUnitsList() {
      var rows = (this.estateUnitsRows || []).map(function (n) {
        var u = Number(n.numberOfUnits), a = Number(n.liveUnits);
        u = isFinite(u) ? u : 0;
        a = isFinite(a) ? a : 0;
        return {
          id: n.id,
          name: n.name,
          units: u,
          active: a,
          pct: u > 0 ? Math.round((a / u) * 100) : null
        };
      });
      rows.sort(function (x, y) { return String(x.name).localeCompare(String(y.name)); });
      return rows;
    },
    estateArpuList() {
      var rows = (this.estateArpuRows || []).map(function (r) {
        var s = Number(r.recurringSales), a = Number(r.accounts);
        return {
          id: r.id,
          name: r.name,
          accounts: isFinite(a) ? a : 0,
          arpu: (isFinite(s) && isFinite(a) && a > 0) ? s / a : null
        };
      });
      rows.sort(function (x, y) { return (y.arpu || 0) - (x.arpu || 0); });
      return rows;
    }
  },
  methods: {
    loadEstateUnits() {
      var self = this;
      Api().get("/locationnetworks/basic/active").then(function (response) {
        self.estateUnitsRows = Array.isArray(response.data) ? response.data : [];
      }).catch(function () { self.estateUnitsRows = []; });
    },
    loadEstateArpu() {
      var self = this;
      var MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      getEstateArpu().then(function (d) {
        self.estateArpuRows = d.rows || [];
        var s = (d.summaries || [])[0];
        var lbl = null;
        if (s && s.periodStart) {
          var p = String(s.periodStart).split("-");
          if (p.length === 3) {
            var mi = parseInt(p[1], 10) - 1;
            if (mi >= 0 && mi < 12) lbl = MONTHS[mi] + " " + p[2];
          }
        }
        self.arpuPeriod = lbl ? "(" + lbl + ")" : "";
      }).catch(function () { self.estateArpuRows = []; });
    },
    navigateServiceAccounts(){
        this.$router.push({ path: "/serviceAccounts"})
    },
    navigateApplications(){
        this.$router.push({ path: "/applications"})
    },
    navigateCancellations(){
        this.$router.push({ path: "/cancellations"})
    },
      async loadCharts(){
        //   Packages Chart
      this.downloadSpeeds = []
      this.tempPackageData = []

      await this.packagedata.map(x => {
         if(this.downloadSpeeds.includes(x.speedProfile.downloadMbps)){
            let find = this.tempPackageData.find(
              z => z.speedProfile.downloadMbps === x.speedProfile.downloadMbps
            );
        let ind = this.tempPackageData.indexOf(find)
            this.tempPackageData[ind].count = this.tempPackageData[ind].count + x.count
         }else{
               this.downloadSpeeds.push(x.speedProfile.downloadMbps)
               this.tempPackageData.push(x)
         }

      })
      let colors = this.getRandomColors(this.tempPackageData.length)
      let networkSpeedColors = this.getRandomColors(this.packagedata.length)
      
      this.ispPackagesChartData = {
        labels: this.tempPackageData.map(x=>x.speedProfile.downloadMbps+'Mbps'),
        datasets: [
        {
            label: 'Speed',
            data: this.tempPackageData.map(x=>x.count),
            backgroundColor: this.tempPackageData.map(x => this.pSBC(0.35, x.colour)),
            borderColor: this.tempPackageData.map(x => x.colour),
            borderWidth: 1
        }]},
        this.ispPackagesChartOptions={
        title: {
            display: true,
            text: 'Packages Sold by Speed'
        },
        tooltip: {
            enabled: true
        }
    }
    // Network Chart
    let networkColors = this.getRandomColors(this.networkdata.length)
    this.networkChartData = {
        labels: this.networkdata.map(x=>x.locationNetwork.name),
        datasets: [
        {
            label: 'Sold',
            data: this.networkdata.map(x=>x.count),
            backgroundColor: networkColors.background,
            borderColor: networkColors.border,
            borderWidth: 1
        }]
        },
        this.networkChartOptions={
        title: {
            display: true,
            text: 'Packages Sold by Network'
        },
        tooltip: {
            enabled: true
        }
    },
    this.ispChartData = {
        labels: this.ispdata.map(x=>x.customerOrganisation.name),
        datasets: [
        {
            label: 'Sold',
            data: this.ispdata.map(x=>x.count),
            backgroundColor: this.pSBC(0.35, this.$vuetify.theme.primary),
            borderColor: this.$vuetify.theme.primary,
            borderWidth: 1
        }]},
        this.ispChartOptions={
            responsive: true, 
      maintainAspectRatio: false,
        title: {
            display: true,
            text: 'Packages Sold by ISP'
        },
        tooltip: {
            enabled: true
        }
    },
    console.log(this.networkspeeds)
    await this.networkspeeds.map(z=>{
          let index = this.networkspeeds.indexOf(z)
          z.backgroundColor = this.pSBC(0.35, z.colour)
          z.borderColor = z.colour;
        })
        this.stackedData = {
        labels: this.networkdata.map(x=>x.locationNetwork.name),
        datasets: this.networkspeeds
        },
      this.stackedDataOptions= {
      responsive: true, 
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true,
          categoryPercentage: 0.8,
          barPercentage: 1
        }],
        yAxes: [{
          stacked: true
        }]
      }}
        
      this.loaded= true

      },
    getRandomColors(number) {
  var letters = '0123456789ABCDEF';
  var color = '#';
  let array = {background: [], border: []}
  for (let x=0; x<number; x++){
      for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  array.border.push(color)
  array.background.push(this.pSBC(0.35, color))
  color = '#'
  }
  return array;
},
pSBC(p,c0,c1,l){
    let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
    if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
    if(!this.pSBCr)this.pSBCr=(d)=>{
        let n=d.length,x={};
        if(n>9){
            [r,g,b,a]=d=d.split(","),n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
        }else{
            if(n==8||n==6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
            else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
        }return x};
    h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
    if(!f||!t)return null;
    if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
    else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
    a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
    if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
    else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
}
  }
};
</script>